import {Injectable} from '@angular/core';
import {ProfileEditService} from '../../../features/profile-edit/profile-edit.service';
import {State} from '../state';
import {StateContext} from '../state.context';
import {switchMap} from "rxjs/operators";
import {EmailVerificationService} from "../../../shared/services/email-verification/email-verification.service";
import {catchError, Observable, throwError} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OtpState implements State {
  name = 'OtpState';

  constructor(
    private stateContext: StateContext,
    private profileEditService: ProfileEditService,
    private emailVerificationService: EmailVerificationService
  ) {}

  start(): void {
    console.debug(`🔑 SERVICE:otp$`);
    this.profileEditService.notifyEmailChange(this.stateContext.getOtpPopupData());
  }

  onSubmit(pinInput: string): Observable<any> {
    return this.emailVerificationService.verifyOtp(pinInput)
      .pipe(
        switchMap(state => state === OtpState ? Promise.resolve() : this.stateContext.changeState(state)),
      catchError( err => {
        console.warn(`🔑 SERVICE:otp$`, err?.message ?? err);
        return throwError(() => err);
      }));

  }

  onResendNewCode(): Observable<any> {
    return this.emailVerificationService.resendOtp()
      .pipe(
        switchMap(state => state === OtpState ? Promise.resolve() : this.stateContext.changeState(state)),
        catchError( err => {
          console.warn(`🔑 SERVICE:otp$`, err?.message ?? err);
          return throwError(() => err);
        }));
  }

}
